import produce from 'immer'
import constants from 'constants/related-projects'

const initialState = {
  projects: {},
  fetching: false,
  doneFetching: false,
  fetchError: '',
  saving: false,
  saveError: ''
}

export default produce((draft, action) => {
  switch (action.type) {
    case constants.FETCH_PROJECTS_REQUEST:
      draft.fetching = true
      break
    case constants.FETCH_PROJECTS_SUCCESS:
      draft.fetching = false
      draft.doneFetching = true
      draft.fetchError = ''
      draft.projects = action.projects
      break
    case constants.FETCH_PROJECTS_FAILURE:
      draft.fetching = false
      draft.doneFetching = true
      draft.fetchError = action.errorMessage
      break
    case constants.SAVE_PROJECTS_REQUEST:
      draft.saving = true
      break
    case constants.SAVE_PROJECTS_SUCCESS:
      draft.saving = false
      draft.saveError = ''
      draft.projects = action.projects
      break
    case constants.SAVE_PROJECTS_FAILURE:
      draft.saving = false
      draft.saveError = action.errorMessage
      break
    case constants.RESET_PROJECTS:
      return initialState
  }
}, initialState)
